import { render, staticRenderFns } from "./Lbc.vue?vue&type=template&id=207ec664&"
import script from "./Lbc.vue?vue&type=script&lang=js&"
export * from "./Lbc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports